import { getOriginalTarget, getActionType, setActionType } from './functionInternals';
import { getGlobalContext } from '../globalContext';
function createCursorFromSelector(selector, args) {
    var state = {};
    Object.keys(selector).forEach(function (key) {
        if (typeof state[key] === typeof undefined) {
            Object.defineProperty(state, key, {
                enumerable: true,
                get: function () { return selector[key].apply(null, args); },
            });
        }
    });
    Object.freeze(state);
    return state;
}
export default function select(selector) {
    return function decorator(target) {
        if (getGlobalContext().legacyTestMode) {
            return target;
        }
        var context = this;
        var argumentPosition = target.length - 1;
        var actionTarget = getOriginalTarget(target);
        if (actionTarget) {
            argumentPosition = actionTarget.length - 1;
        }
        var returnValue = function () {
            var state = createCursorFromSelector(selector, arguments);
            var args = Array.prototype.slice.call(arguments);
            if (typeof args[argumentPosition] === typeof undefined) {
                for (var i = args.length; i < argumentPosition; i++) {
                    args[i] = undefined;
                }
                args[argumentPosition] = state;
            }
            return target.apply(context, args);
        };
        setActionType(returnValue, getActionType(target));
        return returnValue;
    };
}
